import React, { useState } from 'react';
import usePermissionCheck from 'utils/hooks/usePermissionCheck';
import { Col, Row } from 'react-bootstrap';
import { Outlet, useLocation, useNavigate } from 'react-router';
import CentralizedSpinner from 'components/CentralizedSpinner';
import RightSidebar from 'components/Layout/RightSidebar';
import PersonalizedForm from 'components/Flux/Personalized/New/Form';
import { ScenariosDraftProvider } from 'components/Flux/Personalized/New/ScenariosDraftContext';
import TabbedPage from 'components/TabbedPage';
import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import SectionTabs, { SectionTabItem } from 'components/Layout/MobileShell/SectionTabs';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import shortenedTabPath from 'helper/shortenedTabPath';
import useIsMobile from 'utils/hooks/useIsMobile';

// Rótulo mobile encurtado: "Novo Estudo Personalizado" não cabe no título do cabeçalho
const MOBILE_TABS: SectionTabItem[] = [
  { title: 'Meus Estudos', path: '/flux/personalized' },
  { title: 'Novo Estudo', path: '/flux/personalized/new' },
];

export default function FluxPersonalizedWrapper() {
  const keySaved = usePermissionCheck('prevs-personalizado');
  const [showControlPanel, setShowControlPanel] = useState(false);
  const isMobile = useIsMobile();
  const location = useLocation();
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);

  if (!keySaved) {
    return <CentralizedSpinner />;
  }

  if (isMobile) {
    const activeTab = MOBILE_TABS.find(
      (tab) => tab.path === shortenedTabPath(location.pathname),
    );

    return (
      <ScenariosDraftProvider>
        <MobileSectionHeader
          backLabel="Personalizado"
          title={activeTab?.title ?? ''}
          onBack={() => navigate('/flux')}
          onAvatarClick={() => setMoreOpen(true)}
        />
        <SectionTabs tabs={MOBILE_TABS} />
        <Outlet />
        <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
      </ScenariosDraftProvider>
    );
  }

  // Mesmo provider como raiz nos dois ramos: os cenários sobrevivem à troca de breakpoint.
  return (
    <ScenariosDraftProvider>
      <Row>
        <Col className="md-6">
          <h1 className=" mb-3">FLUX - PERSONALIZADO</h1>
        </Col>
      </Row>
      <Row style={{ flexWrap: 'nowrap', paddingBottom: '3.3125rem' }}>
        <Col xs="auto" className="flex-fill overflow-hidden">
          <TabbedPage setControlPanelVisibility={setShowControlPanel}>
            <TabbedPage.Tab title="MEUS ESTUDOS" path="/flux/personalized" />
            <TabbedPage.Tab title="NOVO ESTUDO PERSONALIZADO" path="/flux/personalized/new" showControlPanel />
          </TabbedPage>
        </Col>
        {showControlPanel && (
          <Col xs="auto">
            <RightSidebar>
              <PersonalizedForm />
            </RightSidebar>
          </Col>
        )}
      </Row>
      <div className="bottom-bar" />
    </ScenariosDraftProvider>
  );
}
